import React, { useEffect, useMemo, useState } from "react";
import { ArrowDown, ArrowUp } from "lucide-react";
import { numberLabel } from "../../utils/bondNumbersHelpers";

const randomPreviewNumber = () => 1 + Math.floor(Math.random() * 999);

const BondNumbersStageVisual = ({
  numbers = [],
  referenceNumber = null,
  outcome = null,
  revealing = false,
}) => {
  const hasRound = numbers.length > 0 && referenceNumber != null;
  const [previewValue, setPreviewValue] = useState(() => randomPreviewNumber());

  const candidates = useMemo(
    () => (hasRound ? numbers.filter((n) => Number(n) !== Number(referenceNumber)) : []),
    [hasRound, numbers, referenceNumber]
  );

  const heroValue = hasRound ? referenceNumber : previewValue;
  const showDirection = outcome != null && referenceNumber != null;
  const wentHigher = showDirection && Number(outcome) > Number(referenceNumber);

  useEffect(() => {
    if (hasRound) return undefined;
    const id = window.setInterval(() => {
      setPreviewValue(randomPreviewNumber());
    }, 900);
    return () => window.clearInterval(id);
  }, [hasRound]);

  return (
    <div className={`bnums-visual${revealing ? " revealing" : ""}${!hasRound ? " idle" : ""}`}>
      <div className="bnums-hero-row">
        {showDirection ? (
          <span className={`bnums-dir-pill${wentHigher ? " up" : " down"}`} aria-hidden>
            {wentHigher ? <ArrowUp size={14} strokeWidth={2.5} /> : <ArrowDown size={14} strokeWidth={2.5} />}
          </span>
        ) : null}

        <div className="bnums-reference">
          <span className="bnums-reference-kicker">Reference</span>
          <strong className="bnums-reference-value" key={hasRound ? "locked" : previewValue}>
            {numberLabel(heroValue)}
          </strong>
          <span className="bnums-reference-bar" aria-hidden />
        </div>
      </div>

      {hasRound ? (
        <div className="bnums-rail" aria-label="Candidate numbers">
          {candidates.map((number) => {
            const isReveal = outcome != null && Number(number) === Number(outcome);
            const isHigher = Number(number) > Number(referenceNumber);
            return (
              <span
                key={number}
                className={`bnums-chip${isHigher ? " higher" : " lower"}${isReveal ? " reveal" : ""}`}
              >
                {numberLabel(number)}
              </span>
            );
          })}
        </div>
      ) : (
        <div className="bnums-rail idle" aria-hidden>
          {Array.from({ length: 10 }).map((_, index) => (
            <span key={index} className="bnums-chip idle" />
          ))}
        </div>
      )}
    </div>
  );
};

export default BondNumbersStageVisual;
